module.exports = __webpack_public_path__ + "img/option-api-vs-composition-api-1.42906b3d.png";